import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const CustomRadio = ({
  value, name, checked, onChange, disabled,
}) => (
  <div className={`custom-radio-v2 ${disabled ? 'disabled' : ''}`}>
    <input
      type="radio"
      id={value}
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className="radio-input"
    />
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label htmlFor={value} className="radio-label">
      <span className="custom-radio-button" />
    </label>
  </div>
);

CustomRadio.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default CustomRadio;
